var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLinked24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_linked24x24",
    transform: "translate(-3.108 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(3.108 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24983",
    "data-name": "Group 24983",
    transform: "translate(0 5.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24982",
    "data-name": "Group 24982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46077",
    "data-name": "Path 46077",
    d: "M9.812,165.707a3.629,3.629,0,0,0-.622-.5,3.733,3.733,0,0,0-4.652.5L1.146,169.1a3.733,3.733,0,0,0,5.269,5.281l2.8-2.8a.267.267,0,0,0-.189-.456H8.919a4.487,4.487,0,0,1-1.706-.331.267.267,0,0,0-.291.059l-2.01,2.012A1.6,1.6,0,1,1,2.648,170.6l3.4-3.4a1.6,1.6,0,0,1,2.261,0,1.093,1.093,0,0,0,1.5,0,1.056,1.056,0,0,0,0-1.5Z",
    transform: "translate(-.147 -164.614)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24985",
    "data-name": "Group 24985",
    transform: "translate(5.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24984",
    "data-name": "Group 24984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46078",
    "data-name": "Path 46078",
    d: "M198.486,1.093a3.733,3.733,0,0,0-5.279,0l-2.8,2.794a.267.267,0,0,0,.195.456h.1a4.479,4.479,0,0,1,1.7.333.267.267,0,0,0,.292-.055l2.008-2a1.6,1.6,0,1,1,2.258,2.26l-2.5,2.5-.021.024-.874.869a1.6,1.6,0,0,1-2.261,0,1.093,1.093,0,0,0-1.5,0,1.066,1.066,0,0,0,0,1.5,3.7,3.7,0,0,0,1.066.747c.056.027.112.048.168.072s.115.043.171.064.115.04.171.056l.157.043c.107.027.213.048.323.067a3.71,3.71,0,0,0,.4.037h.2l.16-.019c.059,0,.12-.016.189-.016h.089l.184-.027.089-.016.155-.032h.029a3.732,3.732,0,0,0,1.73-.978l3.394-3.394a3.733,3.733,0,0,0,0-5.284Z",
    transform: "translate(-189.503)",
    fill: "#999"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLinked24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_linked24x24.29ce01dad938eb20e58d3ed5415155b7.svg";